
import CustomerLayout from '../layouts/customer/Layout';
import PublicLayout from '../layouts/public/Layout';

import DashboardPage from '../pages/customer/dashboard/DashboardPage'
import LoginPage from '../pages/customer/access/LoginPage';
import ProfilePage from '../pages/customer/account/ProfilePage';
import PasswordPage from '../pages/customer/account/PasswordPage';

export default function routes(){
    
    return [
        {
        path: '/customer',
        element: <PublicLayout />,
        children: [
            // { element: <Navigate to="dashboard" />, index: true },
            { path: 'login', element: <LoginPage /> }
        ],
        },
        {
        path: '/customer',
        element: <CustomerLayout />,
        children: [
            // { element: <Navigate to="dashboard" />, index: true },
            { path: '', element: <DashboardPage /> },

            { path: 'dashboard', element: <DashboardPage /> },
            { path: 'profile', element: <ProfilePage /> },
            { path: 'password', element: <PasswordPage /> },

        ],
        }
    ]
}